export default {

  vidfleet_configuration_title_bulk: "Opciones de Configuración de VidFleet",
  vidfleet_configuration_imei: "IMEI",
  vidfleet_configuration_manufacturer: "Fabricante",
  vidfleet_configuration_model: "Modelo",
  vidfleet_configuration_esn: "Serial",
  vidfleet_configuration_device_search_criteria: "Serial",
  vidfleet_configuration_device_add: "Agregar",
  vidfleet_configuration_device_not_supported: "Hay dispositivos con fabricante no soportado",
  vidfleet_configuration_sent: "Enviado",
  vidfleet_configuration_sent_message: "Cambio de Script enviado a PULS",
  vidfleet_configuration_only_vidfleet: "No es un dispositivo VidFleet",
  vidfleet_configuration_only_same_model: "No es del mismo modelo",

  vidfleet_configuration_apply_scopes: "Alcances a Aplicar",
  vidfleet_configuration_apply_scopes_default: "Predeterminado",
  vidfleet_configuration_apply_scopes_all: "Todas",
  vidfleet_configuration_apply_scopes_partial: "Parcial",

  vidfleet_configuration_apply_scopes_default_message: 'Éste cambio será aplicado como "POR DEFECTO" para TODOS los nuevos dispositivos adicionados a la PLATAFORMA',
  vidfleet_configuration_apply_scopes_all_message: 'Éste cambio será applicado a "TODOS" los dispositivos existentes en la PLATAFORMA',
  vidfleet_configuration_apply_scopes_partial_message: "Solo los dispositivos listados abajo tomarán esta configuración",
  vidfleet_configuration_apply_scopes_partial_message_2: "Solo los dispositivos seleccionados en el primer paso tomarán esta configuración",

  vidfleet_configuration_apply_settings: "Aplicar Configuración",
  vidfleet_configuration_apply_settings_to: "Aplicar configuración a",
  vidfleet_configuration_apply_settings_to_devices: "dispositivos",

  vidfleet_configuration_change_vidfleet_configuration: "Cambio en la configuración de VidFleet",

  vidfleet_configuration_new_config: "Nueva Configuración",
  vidfleet_configuration_reset_all_config_to_default: "Todas las opciones de configuración se cambiaron al valor por predeterminado",
  vidfleet_configuration_sounds_reset_to_default: "Las opciones de sonido cambiaron al valor predeterminado",
  vidfleet_configuration_new_sound_option: "Opciones de sonido agregadas",
  vidfleet_configuration_adas_sounds: "Sonidos ADAS",

  vidfleet_configuration_event_threshold_reset_to_default: "Opciones de umbrales y eventoscambiados al valor predeterminado",

  vidfleet_configuration_add_more_devices: "Agregar más dispositivos",

  vidfleet_configuration_clone_settings: "Clonar Configuración",
  vidfleet_configuration_choose_manually: "Escoger Manualmente",
  vidfleet_configuration_select_device_message: "Ingresar el ESN de una cámara para clonar la configuración",
  vidfleet_configuration_search_vidfleet_device: "Buscar un dispositivo VidFleet por el Nombre o el ID de la cámara",
  vidfleet_configuration_select_device_message_different_model: "Hay dispositivos de diferentes modelos, es necesario que todos los dispositivos sean del mismo modelo",
  vidfleet_configuration_rewrite_config_message: "La configuración seleccionada va a sobre escribir la configuración de los dispositivos seleccionados, ¿Desea continuar?",
  vidfleet_configuration_save_error: "Hubo un problema guardando la configuración",

  //from tab
  vidfleet_configuration_title: "Configuración predeterminada de VidFleet",

  vidfleet_configuration_save_changes: "Guardar cambios",

  vidfleet_configuration_sounds: "Sonidos",
  vidfleet_configuration_power: "Encendido",
  vidfleet_configuration_event_trigger: "Activador de evento",
  vidfleet_configuration_recording: "Grabación",

  vidfleet_configuration_event_threshold: "Umbral de eventos",
  vidfleet_configuration_acc_value: "Valor de aceleración",
  vidfleet_configuration_brake_value: "Valor de frenado",
  vidfleet_configuration_turn_value: "Valor de giro",

  vidfleet_configuration_acc_step0: "Acc Paso 0",
  vidfleet_configuration_brake_step0: "Feno Paso 0",
  vidfleet_configuration_turn_step0: "Giro Paso 0",

  vidfleet_configuration_acc_step1: "Acc Paso 1",
  vidfleet_configuration_brake_step1: "Freno Paso 1",
  vidfleet_configuration_turn_step1: "Giro Paso 1",

  vidfleet_configuration_acc_duration: "Duración de la aceleración",
  vidfleet_configuration_brake_duration: "Duración del frenado",
  vidfleet_configuration_turn_duration: "Duración del giro",
  vidfleet_configuration_min_value: "El valor minimo para este campo debe ser 0",

  vidfleet_configuration_event_level: "Nivel del evento",
  vidfleet_configuration_hard_accel: "Aceleración dura",
  vidfleet_configuration_hard_break: "Frenado duro",
  vidfleet_configuration_sharp_turn: "Giro brusco",
  vidfleet_configuration_driving_hit: "Choque",
  vidfleet_configuration_power_lost: "Perdida de Poder",
  vidfleet_configuration_potential_incident: "Incidente Potencial",
  vidfleet_configuration_parking_hit: "Choque de estacionamiento",

  vidfleet_configuration_video_streams: "Transmisiones de video",
  vidfleet_configuration_stream0: "Transmisión 0",
  vidfleet_configuration_stream1: "Transmisión 1",
  vidfleet_configuration_quality: "Calidad",

  vidfleet_configuration_delayed_power_off: "Retraso en apagado",
  vidfleet_configuration_seconds: "s",
  vidfleet_configuration_minutes: "min",
  vidfleet_configuration_milli_g: "mg",
  vidfleet_configuration_km_h: "km/h",
  vidfleet_configuration_10_s: "1/10s",
  vidfleet_configuration_milli_volts: "mV",

  vidfleet_configuration_mic: "Micrófono",
  vidfleet_configuration_auto_snapshot: "Instantánea automática",
  vidfleet_configuration_interval: "Intervalo",

  vidfleet_configuration_live_stream_duration: "Duración de la transmisión en vivo",

  vidfleet_configuration_marked_clip_duration: "Duración del clip marcado",

  vidfleet_configuration_acceleration: "Aceleración",
  vidfleet_configuration_manual: "Manual",
  vidfleet_configuration_dms: "DMS",
  vidfleet_configuration_before: "Antes",
  vidfleet_configuration_after: "Después",

  vidfleet_configuration_privacy_mask: "Máscara de privacidad",

  vidfleet_configuration_load_error: "Hubo un error cargando la configuración",
  vidfleet_configuration_save_success: "La configuración se guardo exitosamente",
  vidfleet_configuration_save_error: "La configuración no se pudo guardar",

  vidfleet_configuration_dms_sounds: "Sonidos DMS",
  vidfleet_configuration_using_phone: "Usando el Teléfono",
  vidfleet_configuration_attentive: "Atento",
  vidfleet_configuration_smoking: "Fuamando",
  vidfleet_configuration_drowsiness: "Somnolencia",
  vidfleet_configuration_no_seatbelt: "Sin cinturon",
  vidfleet_configuration_no_driver: "Sin conductor",
  vidfleet_configuration_daydreaming: "Soñador",
  vidfleet_configuration_yawn: "Bostezo",
  vidfleet_configuration_asleep: "Dormido",
  vidfleet_configuration_distracted: "Distraído",

  vidfleet_configuration_min_speed: "Velocidad Mínima",
  vidfleet_configuration_detection_delay: "Detección Retraso",
  vidfleet_configuration_repeat_interval: "Intervalo Repetición",
  vidfleet_configuration_detection_reset: "Detección Reinicio",
  vidfleet_configuration_max_speed: "Velocidad Máxima",
  vidfleet_configuration_over_speed_limit: "Sobre Limite de Velocidad",

  vidfleet_configuration_video_stream_360: "Video Stream (Secure360 SecureES)",
  vidfleet_configuration_video_stream_4k: "Resolución de Video",
  vidfleet_configuration_high_bit_rate: "High bit rate",
  vidfleet_configuration_low_bit_rate: "Low bit rate",
  vidfleet_configuration_video_resolution: "Resolución del video",

  vidfleet_configuration_other_settings: "Otras configuraciones",

  vidfleet_configuration_default: "Predeterminado",
  vidfleet_configuration_custom: "Personalizado",

  vidfleet_configuration_event_thresholds_levels: "Umbrales y Eventos",

  vidfleet_configuration_vehicle_class_present: "Clases de vehículos",

  vidfleet_configuration_heavy_duty: "Camiones",
  vidfleet_configuration_light_truck: "Camiones Ligeros (camionetas, SUV)",
  vidfleet_configuration_sedan: "Sedán",

  vidfleet_configuration_thresholds: "Umbrales",
  vidfleet_configuration_levels: "Niveles",

  vidfleet_configuration_super_low: "Super Bajo",
  vidfleet_configuration_low: "Bajo",
  vidfleet_configuration_med: "Medio",
  vidfleet_configuration_high: "Alto",
  vidfleet_configuration_heavy: "Pesado",
  vidfleet_configuration_off: "Off",
  vidfleet_configuration_normal: "Normal",
  vidfleet_configuration_main: "Principal",
  vidfleet_configuration_super: "Super",
  vidfleet_configuration_upside_down: "Al revés",

  vidfleet_configuration_camera_orientation: "Orientación de la Camara",
  vidfleet_configuration_rotate: "Rirar",

  vidfleet_configuration_trust_acc: "Datos de voltaje del ECM (trustAcc)",
  vidfleet_configuration_night_vision: "Visión nocturna",
  vidfleet_configuration_driving_night_vision: "Conducción de visión nocturna",
  vidfleet_configuration_from: "Desde",
  vidfleet_configuration_to: "Hasta",
  vidfleet_configuration_obdii: "OBD_II",
  vidfleet_configuration_obdii_mode: "Modo",
  vidfleet_configuration_voltage: "Voltaje",
  vidfleet_configuration_voltage_on: "Encendido",
  vidfleet_configuration_voltage_off: "Apagado",
  vidfleet_configuration_voltage_check: "Verificación",
  vidfleet_configuration_volume: "Volumen",
  vidfleet_configuration_volume_level: "Nivel",
  vidfleet_configuration_driving_night_vision_on: "Encendida",
  vidfleet_configuration_driving_night_vision_auto: "Automática",
  vidfleet_configuration_driving_night_vision_off: "Apagada",

  vidfleet_configuration_vidfleet_config_save_accepted: "Configuración aceptada por el dispositivo",
  vidfleet_configuration_vidfleet_config_sent: "Configuración enviada al dispositivo",

  vidfleet_configuration_cancel: "Cancelar",

  vidfleet_configuration_expand_all: "Expandir Todo",
  vidfleet_configuration_collapse_all: "Copalsar Todo",

  vidfleet_configuration_restore_all: "Restaurar todo a predeterminado",
  vidfleet_configuration_dms_events: "Eventos DMS",

  vidfleet_configuration_events: "Eventos",

  vidfleet_configuration_adas: "ADAS",
  vidfleet_configuration_nav: "NAV",
  vidfleet_configuration_forward_collision_warning: "Aviso de Colisión",
  vidfleet_configuration_headway_monitoring_warning: "Close Following",
  vidfleet_configuration_headway_monitoring_emergency: "Tailgating",
  vidfleet_configuration_lane_departure_warning: "Aviso de salida de carril",
  vidfleet_configuration_forward_collision: "Colisión frontal",
  vidfleet_configuration_headway_monitoring: "Seguimiento de los avances",
  vidfleet_configuration_lane_departure: "Salida de carril",
  vidfleet_configuration_following_too_closely: "Siguiendo demasiado cerca",
  vidfleet_configuration_forward_collision_warning_adas: "Aviso de colisión",
  vidfleet_configuration_headway_monitoring_warning_adas: "Siguiendo demasiado cerca",

  vidfleet_configuration_forward_collision_warning_adas_title: "Aviso de colisión frontal",
  vidfleet_configuration_headway_monitoring_warning_adas_title: "Aviso de control de avance",
  vidfleet_configuration_headway_monitoring_emergency_adas_title: "Monitorización de la cabeza en caso de emergencia",

  vidfleet_configuration_following_too_closely_adas: "Siguiendo demasiado cerca",
  vidfleet_configuration_tailgating_adas: "Tailgating",
  vidfleet_configuration_forward_collision_adas: "Aviso de colisión",
  vidfleet_configuration_message_time_ratio: "Distancia de seguimiento (tiempo para colisión) en segundos",
  vidfleet_configuration_message_time_ratio_tailgating: "* si esta habilitado, Tailgating es siempre el 50% del valos de Siguiendo demasiado cerca",

  vidfleet_configuration_running_info: "Información sobre el funcionamiento",
  vidfleet_configuration_interval_in_min: "Intervalo En Min",

  vidfleet_configuration_advanced: "Avanzado",
  vidfleet_configuration_sd_card_event: "Tarjeta Sd Espacio para eventos",
  vidfleet_configuration_large: "Grande",
  vidfleet_configuration_medium: "Medio",
  vidfleet_configuration_small: "Pequeño",

  vidfleet_configuration_time_ratio: "Proporción de tiempo",
  vidfleet_configuration_video_resolution_main: "Principal",
  vidfleet_configuration_video_resolution_high: "Alto",
  vidfleet_configuration_video_resolution_low: "Bajo",
  vidfleet_configuration_video_resolution_low_priv: "Bajo Priv",

  vidfleet_configuration_ignition: "Encendido",
  vidfleet_configuration_virtual_mode: "Modo Virtual",

  vidfleet_configuration_camera_height: "Altura de la Cámara",
  vidfleet_configuration_vehicle_width: "Anchura del Vehículo",
  vidfleet_configuration_camera_position_to_center: "Posición de la Cámara al Centro",

  vidfleet_configuration_left: "Izquierda",
  vidfleet_configuration_center: "Centro",
  vidfleet_configuration_right: "Derecha",
  vidfleet_configuration_meter: "m",

  vidfleet_configuration_sound_dms: "Sonido DMS",
  vidfleet_configuration_without_changes: "Sin cambios",

  vidfleet_configuration_video_streams_reset_to_default: "Transmisión de video cambiado a los valores predeterminados",
  vidfleet_configuration_new_video_streams_options: "Nueva configuración de transmisión de video",
  vidfleet_configuration_new_night_vision_options: "Nueva configuración de visión nocturna",
  vidfleet_configuration_night_vision_reset_to_default: "Vision nocturna cambada a los valores predeterminados",
  vidfleet_configuration_night_vision_driving_time: "tiempo de conducción de visión nocturna",

  vidfleet_configuration_new_auto_snapshot_options: "Nueva configuración de istantanea automática",
  vidfleet_configuration_auto_snapshot_reset_to_default: "Automática instantanea cambiada a valores predeterminados",

  vidfleet_configuration_video_resolution_reset_to_default: "Resolucion de video cambada a valores predeterminados",

  vidfleet_configuration_privacy_mask_reset_to_default: "Mascara de privacidad cambiada al valor predeterminado",
  vidfleet_configuration_new_privacy_mask_options: "Nueva configuración de mascara de privacidad",

  vidfleet_configuration_volume_reset_to_default: "Volumen cambiado a valor por predeterminado",
  vidfleet_configuration_new_volume_options: "Nueva configuración de volumen",

  vidfleet_configuration_obdii_reset_to_default: "OBDII cambiado a valores por defecto",
  vidfleet_configuration_new_obdii_options: "Nueva configuración de OBDII",

  vidfleet_configuration_ignition_reset_to_default: "Encendido cambiado al valor predeterminado",
  vidfleet_configuration_new_ignition_options: "Nueva configuración de encendido",

  vidfleet_configuration_advanced_reset_to_default: "Avanzado cambiado a valores predeterminados",
  vidfleet_configuration_new_advanced_options: "Nuevos valores de opciones en avanzado",

  vidfleet_configuration_dms_reset_to_default: "DMS cambiado a valores predeterminados",
  vidfleet_configuration_new_dms_options: "Nuevos valores de DMS",

  vidfleet_configuration_threshold: "Umbrales",

  vidfleet_configuration_options_changed: "Opciones de configuración que va a ser modificadas o adicionadas:",

  vidfleet_configuration_event_level_reset_to_default: "Niveles de eventos cambiados a valor por defecto",
  vidfleet_configuration_new_event_level_options: "Nuevos valores de niveles de eventos",

  vidfleet_configuration_invalid_night_vision_time: "Invalid night vision time",

  vidfleet_configuration_video_resolution_front_only: "Sólo el Frente",
  vidfleet_configuration_video_resolution_incabin_dms: "DMS en Cabina",

  vidfleet_configuration_video_resolution_front_only_message: "Cuando 'Sólo el Frente' esté seleccionado, el monitoreo de DMS no funcionará",

  vidfleet_configuration_headway_monitoring_warning_label: "*Habilita ambas opciones Close Following y Tailgating",
  vidfleet_configuration_headway_monitoring_emergency_label: "*Habilita solamente Tailgating",

  vidfleet_configuration_change_history: "Historial de Cambios",

  vidfleet_configuration_lang: "Lenguaje",
  vidfleet_configuration_english: "Inglés",
  vidfleet_configuration_spanish: "Español",

  vidfleet_configuration_config_upload_mode: "Configurar Modo de Carga",

  vidfleet_configuration_level: "Nivel",
  vidfleet_configuration_off: "Apagado",
  vidfleet_configuration_lite: "Ligero",
  vidfleet_configuration_standard: "Estándar",

  vidfleet_configuration_na: "NA (Sin Auxiliar)",
  vidfleet_configuration_ecm01: "ECM01 (Sensor DMS)",
  vidfleet_configuration_ecm02: "ECM02 (Cámara Auxiliar)",
  vidfleet_configuration_ecm03: "ECM03 (Cámara Auxiliar)",

  vidfleet_configuration_aux: "Cámara Auxiliar",
  vidfleet_configuration_model: "Modelo",
  vidfleet_configuration_angle: "Ángulo",
  vidfleet_configuration_model2: "Modelo 2",
  vidfleet_configuration_angle2: "Ángulo 2",


  vidfleet_configuration_angle_normal: "Normal",
  vidfleet_configuration_angle_upsidedown: "Al Revés",
  vidfleet_configuration_angle_rotate_right: "Rotar a la derecha",
  vidfleet_configuration_angle_rotate_left: "Rotar a la izquierda",

  vidfleet_configuration_select_aux_camera: "*Si la cámara tiene instalada la cámara auxiliar opcional, se debe seleccionar el perfil Bajo o Principal",
  vidfleet_configuration_dms_level_off: "*No DMS",
  vidfleet_configuration_dms_level_lite: "*DMS sobre la cámara principal, soportando los eventos USING_PHONE, DISTRACTED, NO_SEATBELT, YAWN",
  vidfleet_configuration_dms_level_standard: "*DMS a través de la cámara separada/externa opcional compatible con todos los tipos de eventos DMS",
  vidfleet_configuration_adas_level_off: "*No ADAS",
  vidfleet_configuration_adas_level_standard: "Soporta los tipos de eventos FORWARD_COLLISION, HEADWAY_MONITORING, LANE_DEPARTURE",
  vidfleet_configuration_combination_not_allowed: "La combinación de recordConfig / adasLevel / dmsLevel / auxModel / privacyControl no esta permitida",

  vidfleet_configuration_message_available_combinations: "Click para ver las combinaciones permitidas",

  vidfleet_configuration_repetead_on_the_list: "Dispositivo repetido en la lista",
  vidfleet_configuration_device_model: "Modelo",
  vidfleet_configuration_only_vidfleet_devices: "Solo dispositivos Vidfleet",
  vidfleet_configuration_device_not_found: "Dispositivo no encontrado",
  vidfleet_configuration_incomplete_status: "Estatus incompleto",
  vidfleet_configuration_search_criteria: "Ingresar un serial",
  vidfleet_configuration_add: "Agregar",

  vidfleet_configuration_error_200: "Error en la contraseña de la cámara",
  vidfleet_configuration_error_201: "Falló la operación de la cámara",
  vidfleet_configuration_error_202: "La cámaraa no existe",
  vidfleet_configuration_error_204: "Error en la syncronización de la cámara",
  vidfleet_configuration_error_24: "Sin autorización de acceso a la cámara",
  vidfleet_configuration_error_23: "Fallo en la autenticación",
  vidfleet_configuration_empty: "Por favor seleccione alguna opción antes de enviar la configuración",
  vidfleet_configuration_verification_code: "Código de Verificación",
  vidfleet_configuration_send_verification_code: "Enviar Código de Verificación",
  vidfleet_configuration_vf_code_sent: "Un código de seguridad, ha sido enviado a su correo electrónico",
  vidfleet_configuration_vf_code_error: "No se pudo enviar el código de seguridad a su correo electrónico",
  vidfleet_configuration_cev: "Validación de Eventos en la Nube (CEV)",
  vidfleet_configuration_cev_no_seatbelt: "Sin Cinturón de Seguridad",
  vidfleet_configuration_cev_using_phone: "Uso del Teléfono",
  vidfleet_configuration_cev_no_driver: "Sin Conductor",
  vidfleet_configuration_cev_passengers_no_seatbelt: "Pasajeros Sin Cinturón de Seguridad",
  vidfleet_configuration_cev_smoking: "Fumando",
  vidfleet_configuration_cev_potential_incident: "Incidente Potencial",
  vidfleet_configuration_cev_using_phone_warning: "CEV se omite para los eventos de Uso del Teléfono cuando el control de privacidad de la cámara difumina rostros o su configuración de grabación es Solo Frontal.",
  vidfleet_configuration_cev_events: "Eventos",
  vidfleet_configuration_disabled: "Deshabilitado",
  vidfleet_configuration_timezone: "Zona Horaria",
  vidfleet_configuration_timezone_offset: "Desplazamiento",
  vidfleet_configuration_timezone_label: "Zona Horaria",
  vidfleet_configuration_timezone_by: "Zona horaria seleccionada por",
  vidfleet_configuration_timezone_subtitle: "Subtitle",
  vidfleet_configuration_stop_sign_violation: "Violación de la señal de alto",
  vidfleet_configuration_advanced_parking_heart_beat: "Parking Heart Beat",
  vidfleet_configuration_idle_no_driver: "Inactivo sin conductor",
  vidfleet_configuration_aux_camera_disable: "* esta opción se encuentra deshabilitada, revisa si el firmware de la camara es mayor o igual 2.30.179.48.476",
  vidfleet_configuration_options_default: "La configuración a aplicar, será la configuración por defecto",
  vidfleet_configuration_label_options: "Lista Etiquetas de Configuración",
  vidfleet_configuration_json_options: "JSON Opciones de Configuración",
  vidfleet_configuration_safety_assistance: "Asistencia de seguridad",
  vidfleet_configuration_duration: "Duración",
  vidfleet_configuration_speeding: "Exceso de velocidad",
  vidfleet_configuration_privacy_control: "Control de privacidad",
  vidfleet_configuration_none: "Ninguno",
  vidfleet_configuration_in_cabin: "En cabina",
  vidfleet_configuration_passenger: "Pasajero",
  vidfleet_configuration_driver: "Conductor",
  vidfleet_configuration_permission_message: "Se requiere permiso para modificar los umbrales",
  vidfleet_configuration_view_restrictions: "Ver restricciones",
  vidfleet_configuration_speed: "Velocidad",
  vidfleet_configuration_subtitle: "Subtítulo",
  vidfleet_configuration_disable: "Desactivar",
  vidfleet_configuration_live_photo: "Foto en Vivo",
  vidfleet_configuration_config_hubspot: "Configurar Punto de Acceso",
  vidfleet_configuration_subtitle_timezone_gtmz: "GMT%z",
  vidfleet_configuration_subtitle_timezone_name: "Nombre",
  vidfleet_configuration_gps: "GPS",
  vidfleet_configuration_driver_id: "Identificación del conductor",
  vidfleet_configuration_upload_face: "Cargar Rostro",
  vidfleet_configuration_data_upload: "Carga de datos",
  vidfleet_configuration_upload_interval: "Intervalo de carga",
  vidfleet_configuration_upload_mode: "Modo de carga",
  vidfleet_configuration_upload_mode_hybrid: "Híbrido",
  vidfleet_configuration_upload_mode_default: "Por defecto",
  vidfleet_configuration_upload_mode_hybrid_msg: "La información OBDII se incluirá en el paquete Información de viaje",
  vidfleet_configuration_upload_face_helper: "Cuando se activa, esto activa eventos de reconocimiento facial que activan la función 'inicio de sesión/cierre de sesión automático'",
  vidfleet_configuration_auto_mode: "Auto Modo",
  vidfleet_configuration_passengers_inside: "Pasajeros dentro",
  vidfleet_configuration_over_max_speeding: "Exceso de velocidad máxima",
  vidfleet_configuration_passengers_no_seatbelt: "Pasajeros sin cinturon",
  vidfleet_configuration_pedestrian_collision: "Colisión con peaton",
  vidfleet_configuration_cyclist_collision: "Colisión con ciclista",
  vidfleet_configuration_navigation: "Navegación",
  vidfleet_configuration_count: "Cantidad",
  vidfleet_configuration_count_msg: "Número de repeticiones de este comportamiento para reportar",
  vidfleet_configuration_over_max_speed: "Exceso de velocidad",
  vidfleet_configuration_pedestrian: "Peaton",
  vidfleet_configuration_cyclist: "Ciclista",
  vidfleet_configuration_acceleration: "Aceleración",
  vidfleet_configuration_hard_accel: "Aceleración Dura",
  vidfleet_configuration_harsh_accel: "Aceleración Brusca",
  vidfleet_configuration_severe_accel: "Aceleración Severa",
  vidfleet_configuration_hard_brake: "Frenado Duro",
  vidfleet_configuration_harsh_brake: "Frenado Brusco",
  vidfleet_configuration_severe_brake: "Frenado Severo",
  vidfleet_configuration_sharp_turn: "Giro Brusco",
  vidfleet_configuration_harsh_turn: "Giro Brusco",
  vidfleet_configuration_severe_turn: "Giro Severo",
  vidfleet_configuration_event_trigger_msg: "*No se puede configurar 'Disparador de eventos' y 'Aceleración' al mismo tiempo",
  vidfleet_configuration_enable_event_thumbnail: "Habilitar miniatura de evento",
  vidfleet_configuration_trust_acc_msg: "si virtualMode = true，la cámara utiliza una forma híbrida para determinar si la ignición está encendida o apagada, y 'trustAcc' será ignorado. si virtualMode = false, la cámara utiliza la antigua forma de determinar si la ignición está encendida o apagada, que está sujeta al valor de 'trustAcc'. autoMode solo es efectivo para cámaras Air. y si autoMode = true, 'virtualMode' y 'trustAcc' en la configuración de la nube serán ignorados, la cámara debería cambiar entre los 3 modos anteriores automáticamente según alguna lógica interna. si autoMode = false, se referirá a la tabla anterior para determinar el modo de ignición actual.",
  vidfleet_configuration_no_configuration_found: "No se encontró ninguna configuración para este dispositivo, por favor verifique si el dispositivo está registrado en la plataforma vidFleet",

}